/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

type RawSpan = {
  start_time?: string;
  end_time?: string;
};

/**
 * Earliest span start_time and latest span end_time across raw spans.
 * Returns the original timestamp strings.
 */
export const getTraceTimeRange = (
  spans: RawSpan[] | undefined
): { startTime?: string; endTime?: string } => {
  let startTime: string | undefined;
  let endTime: string | undefined;

  (spans ?? []).forEach(({ start_time, end_time }) => {
    if (
      start_time &&
      (!startTime || new Date(start_time) < new Date(startTime))
    ) {
      startTime = start_time;
    }
    if (end_time && (!endTime || new Date(end_time) > new Date(endTime))) {
      endTime = end_time;
    }
  });

  return { startTime, endTime };
};
